"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceByPropertyTypeItem$ = exports.PriceByPropertyTypeItem$outboundSchema = exports.PriceByPropertyTypeItem$inboundSchema = void 0;
exports.priceByPropertyTypeItemToJSON = priceByPropertyTypeItemToJSON;
exports.priceByPropertyTypeItemFromJSON = priceByPropertyTypeItemFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertytype_js_1 = require("./propertytype.js");
/** @internal */
exports.PriceByPropertyTypeItem$inboundSchema = z.object({
    price: z.nullable(z.number()),
    property_type: propertytype_js_1.PropertyType$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.PriceByPropertyTypeItem$outboundSchema = z.object({
    price: z.nullable(z.number()),
    propertyType: propertytype_js_1.PropertyType$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PriceByPropertyTypeItem$;
(function (PriceByPropertyTypeItem$) {
    /** @deprecated use `PriceByPropertyTypeItem$inboundSchema` instead. */
    PriceByPropertyTypeItem$.inboundSchema = exports.PriceByPropertyTypeItem$inboundSchema;
    /** @deprecated use `PriceByPropertyTypeItem$outboundSchema` instead. */
    PriceByPropertyTypeItem$.outboundSchema = exports.PriceByPropertyTypeItem$outboundSchema;
})(PriceByPropertyTypeItem$ || (exports.PriceByPropertyTypeItem$ = PriceByPropertyTypeItem$ = {}));
function priceByPropertyTypeItemToJSON(priceByPropertyTypeItem) {
    return JSON.stringify(exports.PriceByPropertyTypeItem$outboundSchema.parse(priceByPropertyTypeItem));
}
function priceByPropertyTypeItemFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PriceByPropertyTypeItem$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PriceByPropertyTypeItem' from JSON`);
}
//# sourceMappingURL=pricebypropertytypeitem.js.map